/**
 * Constants for RFP Analysis Result feature
 */

export const TEAM_MEMBERS = [
    { id: 1, name: 'James Donovan', role: 'Bid Manager', color: '#2276E9' },
    { id: 2, name: 'Sarah Chen', role: 'Technical Lead', color: '#10B981' },
    { id: 3, name: 'Lisa Park', role: 'Compliance Specialist', color: '#EF4444' },
    { id: 4, name: 'Alex Kim', role: 'Solutions Architect', color: '#2276E9' },
    { id: 5, name: 'Tom Wilson', role: 'Senior Writer', color: '#F59E0B' },
    { id: 6, name: 'Priya Sharma', role: 'Pricing Analyst', color: '#2276E9' },
    { id: 7, name: 'Riya Patel', role: 'Project Manager', color: '#EC4899' },
    { id: 8, name: 'Mike Ross', role: 'Technical Writer', color: '#0EA5E9' }
];

export const excludeKeys = [
    'rfp_id', 'metadata', 'METADATA', 'PROJECT_TYPE', 'project_type',
    'PROJECT_SUBTYPE', 'project_subtype', 'PROPOSAL_TITLE', 'proposal_title',
    'CLIENT_NAME', 'client_name', 'CLIENT_LOCATION', 'client_location', 'client_place',
    'deadline', 'PROPOSAL_DEADLINE', 'proposal_deadline', 'source_documents',
    'filename', 'created_at', 'updated_at', '_id', 'id', 'user_id', 'status', 'extracted_date',
    'QUERY_DEADLINE', 'query_deadline', 'VALUATION', 'valuation',
    'currency', 'CURRENCY', 'PROPOSAL_STAGE', 'proposal_stage', 'INDUSTRY', 'industry',
    'CONFIDENCE', 'confidence', 'REASONING', 'reasoning',
    'VIEW_CONFIG', 'SLIDE_MAPPINGS', 'view_config', 'slide_mappings',
    'versions', 'is_historical'
];

export const tabMapping = {
    'chapter_executive_summary': 'EXECUTIVE SUMMARY',
    'chapter_proposed_solution': 'PROPOSED SOLUTION',
    'chapter_project_requirements': 'PROJECT REQUIREMENTS',
    'chapter_queries': 'QUERIES',
    'chapter_queries_from_rfp': 'QUERIES',
    'chapter_assumptions_made_based_on_rfp': 'ASSUMPTIONS',
    'chapter_assumptions': 'ASSUMPTIONS',
    'chapter_raci_matrix_features': 'RACI MATRIX FEATURES'
};

export const keyDescs = {};

export const STAGE_MAP = {
    // New status code mappings (0-11)
    "0": 1, // UPLOADED
    "1": 1, // ANALYZED
    "2": 2, // IN_PROGRESS
    "3": 2, // SUBMITTED_TO_TL
    "4": 3, // PROPOSAL_FINALISED
    "5": 4, // SUBMITTED_TO_CLIENT
    "6": 5, // ACCEPTED
    "7": 6, // REJECTED
    "8": 1, // GO
    "9": 1, // NO_GO
    "10": 1, // EXPIRED
    "11": 2, // RETURNED_FOR_REFINEMENT

    // Label mappings
    "UPLOADED": 1,
    "Uploaded": 1,
    "ANALYZED": 1,
    "Analyzed": 1,
    "RFP Analyzed": 1,
    "IN_PROGRESS": 2,
    "In-Progress": 2,
    "In Progress": 2,
    "SUBMITTED_TO_TL": 2,
    "Submitted to TL": 2,
    "Submitted to Lead": 2,
    "RFP In Review": 2,
    "PROPOSAL_FINALISED": 3,
    "Proposal Finalised": 3,
    "Proposal Finalized": 3,
    "RFP Finalized": 3,
    "SUBMITTED_TO_CLIENT": 4,
    "Submitted to Client": 4,
    "RFP Submitted": 4,
    "ACCEPTED": 5,
    "Accepted": 5,
    "Client Accepted": 5,
    "REJECTED": 6,
    "Rejected": 6,
    "Client Rejected": 6,
    "GO": 1,
    "Go": 1,
    "NO_GO": 1,
    "No-Go": 1,
    "EXPIRED": 1,
    "Expired": 1,
    "RFP Proposal Expired": 1,
    "RETURNED_FOR_REFINEMENT": 2,
    "Returned for Refinement": 2
};

export const STEPS_MANAGER = [
    { id: 1, label: 'RFP Analyzed' },
    { id: 2, label: 'RFP In Review' },
    { id: 3, label: 'RFP Finalized' },
    { id: 4, label: 'RFP Submitted' }
];

export const STEPS_MEMBER = [
    { id: 1, label: 'RFP Analyzed' },
    { id: 2, label: 'In Progress' },
    { id: 3, label: 'Submitted to Lead' },
    { id: 4, label: 'RFP Finalized' }
];

export const PROGRESS_STEPS_MANAGER = STEPS_MANAGER;
export const PROGRESS_STEPS_MEMBER = STEPS_MEMBER;
